export default __webpack_public_path__ + "static/media/ser2.d3b21db5.jpg";